import { render, staticRenderFns } from "./PlayingCard.vue?vue&type=template&id=09dabb88&scoped=true&"
import script from "./PlayingCard.vue?vue&type=script&lang=ts&"
export * from "./PlayingCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlayingCard.vue?vue&type=style&index=0&id=09dabb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dabb88",
  null
  
)

export default component.exports